import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import Select from 'react-select';
import { GET_SURVEY_TEMPLATE_TAGS } from 'graphql/queries';

const TagsFilter = ({ isGatherTemplate, values, onChange }) => {
  const { data: dataSurveyTemplateTags } = useQuery(GET_SURVEY_TEMPLATE_TAGS, {
    variables: {
      isGatherTemplate: isGatherTemplate || false
    }
  });

  const [datas, setDatas] = useState(values || []);

  const onLocalChange = (e) => {
    setDatas(e);
    onChange(e);
  };

  return (
    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
      <div className="text-sm font-weight-bold">Category</div>
      <div style={{ flex: 1 }}>
        <Select
          options={dataSurveyTemplateTags?.getSurveyTemplateTags || []}
          isMulti
          value={datas}
          getOptionValue={(elm) => elm.id}
          getOptionLabel={(elm) => elm.name}
          onChange={onLocalChange}
        />
      </div>
    </div>
  );
};

export default TagsFilter;
